// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"ecd2d4f6","758":"e0d44eac","876":"9c5b7726"}[chunkId] + ".chunk.js";
};